__turbopack_context__.v({
  "article__slide": "TabsUI-module__33Dctq__article__slide",
  "blok-big-title": "TabsUI-module__33Dctq__blok-big-title",
  "blok-subtitle": "TabsUI-module__33Dctq__blok-subtitle",
  "blok-title": "TabsUI-module__33Dctq__blok-title",
  "carousel": "TabsUI-module__33Dctq__carousel",
  "container": "TabsUI-module__33Dctq__container",
  "gallery-button": "TabsUI-module__33Dctq__gallery-button",
  "gallery-button-wrapper": "TabsUI-module__33Dctq__gallery-button-wrapper",
  "gallery_button": "TabsUI-module__33Dctq__gallery_button",
  "gallery_button_wrapper": "TabsUI-module__33Dctq__gallery_button_wrapper",
  "right": "TabsUI-module__33Dctq__right",
  "root": "TabsUI-module__33Dctq__root",
  "single__tab": "TabsUI-module__33Dctq__single__tab",
  "slide": "TabsUI-module__33Dctq__slide",
  "tags": "TabsUI-module__33Dctq__tags",
  "title__spacing": "TabsUI-module__33Dctq__title__spacing",
});
